export const PET_STATES = Object.freeze({
  DRAG_OVER: 'dragOver',
  FEEDING: 'feeding',
  HAPPY: 'happy',
  HOVER: 'hover',
  HUNGRY: 'hungry',
  IDLE: 'idle',
  SAD: 'sad',
  SLEEPING: 'sleeping',
  SUCCESS: 'success',
  THINKING: 'thinking',
})

export const PET_EVENTS = Object.freeze({
  ANALYSIS_FAILED: 'analysis_failed',
  ANALYSIS_START: 'analysis_start',
  ANALYSIS_SUCCESS: 'analysis_success',
  CHECKIN_SUCCESS: 'checkin_success',
  DRAG_PROJECT_DROP: 'drag_project_drop',
  DRAG_PROJECT_ENTER: 'drag_project_enter',
  FEED_FAILED_NO_FOOD: 'feed_failed_no_food',
  FEED_SUCCESS: 'feed_success',
})

const VALID_STATES = new Set(Object.values(PET_STATES))

export function normalizePetState(state) {
  if (state === 'analyzing' || state === 'catching') return PET_STATES.THINKING
  return VALID_STATES.has(state) ? state : PET_STATES.IDLE
}

export function resolvePetState({
  actionLoading = '',
  dropActive = false,
  foodCount = 0,
  hovering = false,
  moment = '',
  mood = '',
} = {}) {
  if (dropActive) return PET_STATES.DRAG_OVER
  if (moment === 'catching' || moment === 'analyzing' || moment === PET_STATES.THINKING) {
    return PET_STATES.THINKING
  }
  if (moment === PET_STATES.SUCCESS) return PET_STATES.SUCCESS
  if (moment === PET_STATES.SAD) return PET_STATES.SAD
  if (moment === PET_STATES.FEEDING || actionLoading === 'feed') return PET_STATES.FEEDING

  const normalizedMood = String(mood || '').toLowerCase()
  if (normalizedMood === 'hungry' || mood === '饿了' || Number(foodCount || 0) <= 0) {
    return PET_STATES.HUNGRY
  }
  if (['happy', 'full', '开心', '饱饱的'].includes(mood) || normalizedMood === 'happy') {
    return PET_STATES.HAPPY
  }
  if (hovering) return PET_STATES.HOVER
  return PET_STATES.IDLE
}

export function transitionPetState(currentState, eventName) {
  const state = normalizePetState(currentState)
  switch (eventName) {
    case PET_EVENTS.FEED_SUCCESS:
    case PET_EVENTS.CHECKIN_SUCCESS:
      return PET_STATES.HAPPY
    case PET_EVENTS.FEED_FAILED_NO_FOOD:
      return PET_STATES.HUNGRY
    case PET_EVENTS.DRAG_PROJECT_ENTER:
      return PET_STATES.DRAG_OVER
    case PET_EVENTS.DRAG_PROJECT_DROP:
    case PET_EVENTS.ANALYSIS_START:
      return PET_STATES.THINKING
    case PET_EVENTS.ANALYSIS_SUCCESS:
      return PET_STATES.SUCCESS
    case PET_EVENTS.ANALYSIS_FAILED:
      return PET_STATES.SAD
    default:
      return state
  }
}
